import React, { useState, useEffect } from "react"
import {Box, Typography,} from '@mui/material';
import {AddCircle} from 'iconsax-react';
import styles from '../my-data.module.scss';
import RoundButton from "../../content/shared/components/round-btn";
import LanguageItem from "./language-item";
import DeleteLangModal from "./delete-lang-modal";


const LanguageMenu = ({ show, setShow, window, language, setLanguage, uiStore, page,buttonClicked,menuHandleClose}) => {

    const container = window !== undefined ? () => window().document.body : undefined;
    const { userLanguages } = uiStore;
    const [selectedLang, setSelectedLang] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        if (page !== 'edit-card')
            uiStore?.fetchAllLanguages();
    }, [page, uiStore]);

    const deleteLangFeedback = async () => {
        if (selectedLang === language?.language)
            setLanguage(userLanguages.find(i => i.primary).language)
        setSelectedLang('');
    };

    return (
        <>
            <Box
                container={container}
                variant="temporary"
                sx={{maxHeight: '440px'}}
                open={show}
                onClose={() => setShow(false)}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
            >
                    <>
                        <Box className={styles.mobileMenuHeader}>
                            <Box>
                                <Typography fontSize={18} fontWeight='700'>Info Language</Typography>
                                <Typography color='#888888'>Make cards in different languages</Typography>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', paddingRight: '10px' }}>
                            {userLanguages.map(
                                lang =>
                                    <LanguageItem
                                        key={lang._id}
                                        lang={lang}
                                        language={language}
                                        setLanguage={setLanguage}
                                        forceStopOption={true}
                                        closeDropdown={menuHandleClose}
                                    />
                            )}
                        </Box>

                        {page !== 'edit-card' &&
                            <RoundButton
                                startIcon={
                                    <AddCircle
                                        size="24"
                                        variant="Bulk"
                                    />
                                }
                                variant="contained"
                                color="lightblue"
                                sx={{ mt: 3, ml: 2, width: '90%', justifyContent: 'flex-start' ,bottom: '10px',position: 'sticky'}}
                                onClick={event => {
                                    menuHandleClose();
                                    buttonClicked();
                                }}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile.
                                }}
                            >
                                Manage Language
                            </RoundButton>
                        }
                    </>
            </Box>

            <DeleteLangModal
                lang={selectedLang}
                feedback={deleteLangFeedback}
                show={showDeleteModal}
                setShow={setShowDeleteModal}
                uiStore={uiStore}
            />
        </>
    );
}

export default LanguageMenu;